import React from 'react';
import { useSelector } from 'react-redux';

import { Button } from '@tcc/crate';
import { buildUpgradeUrl } from 'util/urls';
import { getMessage } from 'util/locale';

const baseString = 'vra-management-zones-upgrade';

const ManagementZonesUpgrade = () => {
  const upgradeUrl = useSelector(buildUpgradeUrl);

  return (
    <section className={baseString}>
      <p>{getMessage('text__upgrade-premium-to-use-generate-zones')}</p>
      <Button
        onClick={() => window.location.assign(upgradeUrl)}
        mode='secondary'
        data-test-id={baseString}>
        {getMessage('button-text__upgrade--premium')}
      </Button>
    </section>
  );
};

export default ManagementZonesUpgrade;
